/* eslint-disable react/no-array-index-key */
import { useState, useEffect } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { departmentIcons } from 'react-scale/components/pages/careers/Jobs/data';

const Positions = ({ jobs, selectedDepartment, selectedOffice }) => {
  const [resetAnimation, setResetAnimation] = useState(false);

  const getIconForDepartment = department =>
    departmentIcons[department.toLowerCase()] || '/static/images/pages/careers/jobs/business.svg';

  useEffect(() => {
    setResetAnimation(true);

    // Reset the animation after a short delay
    setTimeout(() => {
      setResetAnimation(false);
    }, 100);
  }, [selectedDepartment, selectedOffice]);

  return (
    <ul className="grid gap-4 mt-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      {jobs.map((j, index) => (
        <li
          className={`opacity-0 ${resetAnimation ? 'animate-none' : 'animate-fadeSlideUp'}`}
          key={index}
          style={{ animationDelay: `${(index + 1) * 50}ms` }}
        >
          <Link
            href={`/careers/${j.id}`}
            className="block w-full h-full px-8 py-8 transition-shadow duration-300 ease-out rounded-lg shadow-md hover:shadow-xl"
          >
            <Image
              width={40}
              height={40}
              src={getIconForDepartment(j.departments[0].name)}
              alt="icon for category"
            />
            <h3 className="mt-6 text-sm font-semibold">{j.title}</h3>
            <div className="mt-4 text-sm text-neutral-600">{j.location.name}</div>
            <div className="mt-4 text-sm text-link">Read More</div>
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default Positions;
